import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';

import {
  BaseText,
  HeadingDisplay,
  DataTable,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import {
  IMarginAllocationPreviewV2,
  IMarginAllocationV2
} from '@/modules/trade/services/margin-allocation';

import {
  EMarginAllocationSteps,
  formattedData
} from '@/modules/trade/views/MarginAllocationV2/helpers';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface IDataForm {
  isUpdatingLimits: boolean;
  balance: { value: number; formatted: string };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceInput',
  setup(__props) {

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<IDataForm>;
const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const balanceFormatted = ref('');
const balanceValue = ref(0);

const tableColumns = [
  {
    label: 'Ativo',
    align: 'left',
    getter: 'ticker'
  },
  {
    label: 'Exposição máxima',
    align: 'right',
    getter: 'maxExpose'
  }
];

const tableData = computed(() => {
  return formattedData(
    marginAllocationPreview.value.variationTable,
    balanceValue.value
  );
});

const isDisabled = computed(() => {
  return (
    balanceValue.value < minAllocation.value.value || status.value === 'error'
  );
});

const availableBalance = computed(() => {
  return marginAllocation.value.availableBalance.value;
});

const minAllocation = computed(() => {
  return marginAllocation.value.minimumMarginCapital;
});

const status = computed(() => {
  if (
    balanceValue.value > 0 &&
    balanceValue.value < minAllocation.value.value
  ) {
    return 'error';
  }

  if (balanceValue.value > 0 && balanceValue.value > availableBalance.value) {
    return 'error';
  }

  return '';
});

const helperText = computed(() => {
  if (
    balanceValue.value > 0 &&
    balanceValue.value < minAllocation.value.value
  ) {
    return `Valor mínimo para alocação é ${minAllocation.value.formatted}`;
  }

  if (balanceValue.value > 0 && balanceValue.value > availableBalance.value) {
    return `Valor superior ao saldo disponível ${marginAllocation.value.availableBalance.formatted}`;
  }

  return '';
});

const initialValue = computed(() => {
  return dataForm.value.balance.formatted.slice(3, -3);
});

function onChangeValue(data: { value: number }) {
  balanceFormatted.value = moneyFormat(data.value);
  balanceValue.value = data.value;
}

function nextStep() {
  updateDataForm('balance', {
    value: balanceValue.value,
    formatted: balanceFormatted.value
  });

  changeStep(EMarginAllocationSteps.DRAWDOWN);
}

onMounted(() => {
  balanceValue.value = dataForm.value.balance.value;
  balanceFormatted.value = moneyFormat(dataForm.value.balance.value);
});

return { __sfc: true,changeStep, updateDataForm, dataForm, marginAllocationPreview, marginAllocation, balanceFormatted, balanceValue, tableColumns, tableData, isDisabled, availableBalance, minAllocation, status, helperText, initialValue, onChangeValue, nextStep, BaseText, HeadingDisplay, DataTable, ButtonContainer, ButtonPrimary, SingleInputMoney, NebraskaColors }
}

})